export class AddtionalFreeItemModel {
  public additionalFreeItemMasterHashId:string;
  public sharedVehicleDriverHashId: string;
  public amount:string;
  public dateAwaredDatetime:string;
  public type:string;
  public driverName:string;
  public subscriptionName:string;
  public sharedVehicleGroup:string;
  public isChecked: boolean;
  public createdBy:string;
  public createdDatetime:string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/additionalfreeitem/models/additionalfreeitems.model.ts